const startsWith = require('lodash/startsWith');
const Lang = require('lang');

function imagePreview(file, success, error) {
  const reader = new FileReader();
  const deferred = jQuery.Deferred();

  if(!startsWith(file.type, 'image')) {
    if(bootbox) {
      bootbox.alert({
        size: 'small',
        title: Lang.get('js/src/functions/imagePreview.invalid_file'),
        message: Lang.get('js/src/functions/imagePreview.image_file_required_message')
      });
    } else {
      alert(Lang.get('js/src/functions/imagePreview.please_image_file_required_message'));
    }
    deferred.reject();
  }

  reader.onload = function(e) {
    deferred.resolve(e.target.result);
  };

  reader.readAsDataURL(file);

  return deferred;
}

module.exports = imagePreview;
